import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import CommonMenu, { MENU_ITEM_TYPES } from '../../../components/common-menu/CommonMenu';
import i18n from '../../../i18n';
import { logout } from '../../../service/callApi';
import CommonButton from '../../../components/common-button/CommonButton';

import './UserMenu.scss';

const UserMenu = ({ onClose, username, onChangePassword, formattedName }) => {
  const { t } = useTranslation('header');

  const handleLanguageChange = useCallback(
    (selectedItem) => {
      i18n.changeLanguage(selectedItem.value);
      window.localStorage.setItem('LANG', selectedItem.value);
      onClose();
    },
    [onClose],
  );

  const userMenuOptions = useMemo(
    () => [
      {
        label: t('settings'),
        value: 'settings',
        disabled: true,
      },
      {
        label: t('changePassword'),
        value: 'changePassword',
        disabled: !username,
        onClick: () => onChangePassword(),
      },
      {
        label: t('language'),
        value: 'language',
        type: MENU_ITEM_TYPES.SUBMENU,
        onSelect: (lang) => handleLanguageChange(lang),
        submenuOptions: [
          {
            label: t('english'),
            value: 'en',
          },
          {
            label: t('german'),
            value: 'de',
          },
        ],
      },
      {
        label: (
          <div className='logout_block'>
            <span className='logout_name'>{formattedName}</span>
            <CommonButton styleColor='secondary' onClick={logout}>
              {t('logout')}
            </CommonButton>
          </div>
        ),
        value: 'logout',
      },
    ],
    [t, handleLanguageChange, onChangePassword, username, formattedName],
  );

  const selectMenuOption = useCallback(
    (selectedItem) => {
      if (selectedItem.onClick) {
        selectedItem.onClick();
      }
      onClose();
    },
    [onClose],
  );

  return <CommonMenu options={userMenuOptions} onSelect={selectMenuOption} />;
};

export default UserMenu;
